import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import { PhotoRequestsResource } from '../../../core/resources/photoRequests.resource';
import { IApiPhotoRequestsResult } from '../../../models/photoRequests';
import { photoRequestsNormalizer } from './photoRequests.normalizer';

export const PAGE_SIZE = 1000; // TMP remove when pagination in WS is functional

export function* getPhotoRequests(
  pageNumber: number,
  pageSize: number = PAGE_SIZE
) {
  const accountId: string = yield select(selectAccountId);
  const response: IApiPhotoRequestsResult = yield call(
    PhotoRequestsResource.getPhotoRequests,
    accountId,
    pageNumber,
    pageSize
  );

  return photoRequestsNormalizer(response);
}

export function* postPhotoRequest(receiverId: string) {
  yield call(PhotoRequestsResource.postPhotoRequest, receiverId);
}
